import { DataCollection } from '@esportal/portal-service';
import {
	Breakpoints,
	Container,
	ContainerPadding,
	Layout,
	Text,
	ThemeProvider,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import { DataCollectionContainer } from './data-collection';
import { UserProfileContainer } from './user-profile';
import { COLOR_TOKEN, contrastBackground } from '../../helpers/color-tokens';

const UserSectionLayout = styled(Layout)`
	background: ${contrastBackground};
`;

const UserProfileWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
	background: ${COLOR_TOKEN.gradient.top};
	border-radius: 16px;
`;

const DataCollectionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
	background: ${COLOR_TOKEN.background.tertiary};
	border-radius: 16px;
`;

export function UserSection({
	setUpdating,
	dataCollection,
	isJourneyLayerVisible,
}: {
	setUpdating: React.Dispatch<React.SetStateAction<boolean>>;
	dataCollection: DataCollection;
	isJourneyLayerVisible: boolean;
}) {
	return (
		<UserSectionLayout
			data-testid="user-section"
			appearance={{
				[Breakpoints.default]: [
					{ name: '.', columns: 1 },
					{ name: 'user-section-title', columns: 22 },
					{ name: '.', columns: 1 },
					{ name: 'user-section-content', columns: 24 },
				],
			}}
		>
			<Container
				data-testid="user-section-title"
				wrap={'always'}
				padding={{
					top: {
						[Breakpoints.default]: ContainerPadding.dynamic0250,
						[Breakpoints.b560]: ContainerPadding.dynamic0200,
					},
					bottom: ContainerPadding.dynamic0250,
				}}
			>
				<Text appearance={TokenTextAppearance.bigcopy200} bold>
					Usuario
				</Text>
				<Text appearance={TokenTextAppearance.headline500}>Tu perfil de miembro</Text>
			</Container>

			<Container
				data-testid="user-section-content"
				wrap={'always'}
				padding={{
					bottom: ContainerPadding.dynamic0200,
				}}
			>
				<Layout
					appearance={{
						[Breakpoints.default]: [
							{ name: '.', columns: 1 },
							{ name: 'user-profile', columns: 22 },
							{ name: '.', columns: 1 },
							{ name: 'gap', columns: 24 },
							{ name: '.', columns: 1 },
							{ name: 'data-collection', columns: 22 },
							{ name: '.', columns: 1 },
						],
						[Breakpoints.b560]: [
							{ name: '.', columns: 1 },
							{ name: 'user-profile', columns: 10 },
							{ name: 'gap', columns: 1 },
							{ name: 'data-collection', columns: 11 },
							{ name: '.', columns: 1 },
						],
						[Breakpoints.b960]: [
							{ name: '.', columns: 1 },
							{ name: 'user-profile', columns: 7 },
							{ name: 'gap', columns: 1 },
							{ name: 'data-collection', columns: 14 },
							{ name: '.', columns: 1 },
						],
						[Breakpoints.b1280]: [
							{ name: '.', columns: 1 },
							{ name: 'user-profile', columns: 6 },
							{ name: 'gap', columns: 1 },
							{ name: 'data-collection', columns: 15 },
							{ name: '.', columns: 1 },
						],
					}}
				>
					<UserProfileWrapper>
						<ThemeProvider theme={'inverted'}>
							<UserProfileContainer setUpdating={setUpdating} />
						</ThemeProvider>
					</UserProfileWrapper>
					<Container padding={{ bottom: ContainerPadding.dynamic0200 }}>
						<span></span>
					</Container>
					<DataCollectionWrapper>
						<DataCollectionContainer dataCollection={dataCollection} isJourneyLayerVisible={isJourneyLayerVisible} />
					</DataCollectionWrapper>
				</Layout>
			</Container>
		</UserSectionLayout>
	);
}
